import { BookingReducerState, BookingStep } from '../types'
import { DefaultFinderPartySize } from '../constants'

const bookingInitialState: BookingReducerState = {
  finderParams: null,
  finderResults: [],
  finderFetchPending: false,
  finderError: null,
  finderRequestId: null,

  widget: null,
  widgetFetchPending: false,
  widgetError: null,

  step: BookingStep.Party,
  bookingTypeId: null,
  partySize: DefaultFinderPartySize,
  businessDate: null,
  selectedStartsAt: null,
  packageId: null,

  availability: null,
  availabilityFetchPending: false,
  availabilityError: null,
  availabilityRequestId: null,

  upsellSelections: [],
  specialRequest: '',
  isCompanyBooking: false,

  reservation: null,
  holdLost: false,

  waitlistEntry: null,

  writePending: null,
  writeError: null,
  idempotencyKeys: {},

  visits: [],
  visitsFetchPending: false,
}

export default bookingInitialState
